var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('prism-editor',{staticClass:"prsim-editor",attrs:{"language":_vm.getLanguage,"lineNumbers":_vm.lineNumbers,"readonly":_vm.readonly},model:{value:(_vm.code),callback:function ($$v) {_vm.code=$$v},expression:"code"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }